export const DATA_TEST_IDS = {
  SECTION: 'cut_music_section',
  TITLE: 'cut_music_title',
  CUT_SELECT: 'cut_music_cut_select',
  OVERLAP_SELECT: 'cut_music_overlap_select',
  CUT_HELP: 'cut_music_help_button',
  OVERLAP_HELP: 'cut_music_overlap_help_button',
  RADIO_GROUP: 'cut_music_radio_group',
  RADIO: (duration: number) => `cut_music_radio_${duration}`,
  OPTION: (value: string) => `cut_music_${value}`,
  TOOLTIP: (elementId: string) => `${elementId}_tooltip`,
  EXAMPLE_PANEL: 'cut_music_help_example_panel',
  EXAMPLE_TOGGLE: 'cut_music_help_example_toggle',
  EXAMPLE_CONTENT: 'cut_music_help_example_content',
  REASON: (value: string) => `cut_music_${value}_reason`,
};
